import { render, staticRenderFns } from "./Transacoes.vue?vue&type=template&id=6c8a2bf4"
import script from "./Transacoes.vue?vue&type=script&lang=js"
export * from "./Transacoes.vue?vue&type=script&lang=js"
import style0 from "./Transacoes.vue?vue&type=style&index=0&id=6c8a2bf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports